import React from "react"
import { Switch, Route } from "react-router-dom"
import "@aws-amplify/ui/dist/style.css"

// import AnnouncementsView from "./Announcements"
import AssociationsView from "./Associations"
// import OverviewView from "./Overview"
import CreateDisclosureView from "./CreateDisclosure"
import DisclosuresView from "./Disclosures"
import DisclosureView from "./Disclosure"
import UpdateDisclosureView from "./UpdateDisclosure"
import DiscussionView from "./DiscussionNew"
import DocumentsView from "./Documents"
import DocumentsSendView from "./DocumentsSend"
import InviteView from "./Invite"
import ProfileView from "./Profile"
import ProfileEditView from "./ProfileEdit"
import ProfilePasswordView from "./ProfilePassword"
// import SettingsView from "./Settings"

export default function Protected() {
  return (
    <Switch>
      {/* <Route path="/0/announcements">
        <AnnouncementsView />
      </Route> */}
      <Route path="/0/associations">
        <AssociationsView />
      </Route>
      <Route path="/0/discussion">
        <DiscussionView />
      </Route>
      <Route path="/0/documents/send">
        <DocumentsSendView />
      </Route>
      <Route path="/0/documents">
        <DocumentsView />
      </Route>
      <Route path="/0/invite">
        <InviteView />
      </Route>
      <Route path="/0/members">
        <InviteView />
      </Route>
      <Route exact path="/0/profile">
        <ProfileView />
      </Route>
      <Route exact path="/0/profile/edit">
        <ProfileEditView />
      </Route>
      <Route exact path="/0/profile/password">
        <ProfilePasswordView />
      </Route>
      <Route exact path="/0/sale">
        <DisclosuresView />
      </Route>
      <Route exact path="/0/sale/add">
        <CreateDisclosureView />
      </Route>
      <Route exact path="/0/sale/:disclosure_id/edit">
        <UpdateDisclosureView />
      </Route>
      <Route exact path="/0/sale/:disclosure_id">
        <DisclosureView />
      </Route>
      {/* <Route path="/0/settings">
        <SettingsView />
      </Route> */}
      <Route path="*">
        <DiscussionView />
      </Route>
    </Switch>
  )
}
